export enum SystemType {
    L1 = "L1",
    L2 = "L2",
}
